import * as React from 'react';
import { Alert } from '@/ui';

export type ErrorAlertVariant = 'danger' | 'warning' | 'info';

export interface ErrorAlertProps {
  show: boolean;
  message: React.ReactNode;
  variant?: ErrorAlertVariant;
  testId?: string;
  className?: string;
}

/** Inline validation alert. Renders nothing unless `show`. */
const ErrorAlert = ({ show, message, variant = 'danger', testId, className }: ErrorAlertProps) => {
  if (!show) return null;
  return (
    <Alert color={variant} data-testid={testId} className={className} sx={{ mt: 1 }}>
      {message}
    </Alert>
  );
};

export interface ErrorAlertListProps {
  errors?: ErrorAlertProps[];
}

/** Renders several validation alerts from an array of error configurations. */
export const ErrorAlertList = ({ errors = [] }: ErrorAlertListProps) => (
  <>
    {errors.map((error, index) => (
      <ErrorAlert
        key={error.testId || index}
        show={error.show}
        message={error.message}
        variant={error.variant}
        testId={error.testId}
        className={error.className}
      />
    ))}
  </>
);

export default ErrorAlert;
